// src/hooks/useDebounced.js
// Verzoegert einen Wert, bis der Nutzer eine kurze Pause macht.
//
// Hintergrund: Die Suche in Kunden/Stationen loeste bei JEDEM Tastendruck eine
// Server-Anfrage aus. "Blumen" waren sechs Anfragen hintereinander -- im Buero
// kaum spuerbar, auf LTE im Feld sehr wohl. Jetzt wird erst gesucht, wenn
// 350 ms nichts mehr getippt wurde.

import { useState, useEffect } from 'react';

export function useDebounced(wert, verzoegerung = 350) {
  const [verzoegert, setVerzoegert] = useState(wert);

  useEffect(() => {
    // Leeres Feld sofort durchreichen - "alles anzeigen" soll nicht warten.
    if (wert === '') { setVerzoegert(''); return; }
    const t = setTimeout(() => setVerzoegert(wert), verzoegerung);
    return () => clearTimeout(t);
  }, [wert, verzoegerung]);

  return verzoegert;
}
